module.exports = "https://web-assets.ifttt.com/packs/media/stencils/long-post-8f967c74.svg";